import { useEffect } from "react";

const Cta = () => {
  useEffect(() => {
    const textElement = document.querySelector(".AnimatedText p");
    if (textElement) {
      textElement.innerHTML = textElement.innerText
        .split("")
        .map((char, i) => `<span style="transform:rotate(${i * 10.3}deg)">${char}</span>`)
        .join("");
    }
  }, []);

  return (
    <section className="section03">
      <div className="container-fluid">
        <div className="col-md-11 mx-auto">
          <div className="row align-items-center">
            <div className="col-lg-10 mb-3">
              <h4 className="cta-heading">Start Your Journey With Us</h4>
            </div>
            <div className="col-lg-2 mb-3">
              <a href="https://seller.parcelx.in/register">
                <div className="circle">
                  <div className="logo">
                    <i className="fal fa-long-arrow-up"></i>
                  </div>
                  <div className="AnimatedText">
                    <p>Join Us&nbsp; Join Us&nbsp; Join Us&nbsp; Join Us</p>
                  </div>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Cta;